import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { INSTANCE_STATE } from '../../../apis/constants';
import AlertMessage from '../../elements/alert-message/AlertMessage';
import Text from '../../elements/text/Text';
import DeleteButton from '../../sections/delete/DeleteButton';
import TabPanel from '../instance-tabs/TabPanel';

const DeletionTab = ({ instance, onDeleteInstance }) => {
  const { t } = useTranslation();

  const instanceBusy = instance.status !== INSTANCE_STATE.RUNNING;

  return (
    <TabPanel index={3} value={3}>
      <Text sx={{ mb: 2 }}>
        {t('settings.deleteInstance', { ns: 'descriptions' })}
      </Text>
      {instanceBusy && (
        <Box sx={{ mb: 2 }}>
          <AlertMessage
            message={t('instanceIsBusy', { ns: 'descriptions' })}
            severity="info"
          />
        </Box>
      )}
      <DeleteButton
        buttonProps={{ disabled: instanceBusy }}
        buttonText={t('deleteInstance', { ns: 'buttons' })}
        description={t('areYouSure', {
          ns: 'descriptions',
          text: t('instance', { ns: 'instance' }),
        })}
        onDelete={onDeleteInstance}
        title={t('deleteInstance', { ns: 'sectionTitles' })}
        validation={instance.name}
      />
    </TabPanel>
  );
};

DeletionTab.propTypes = {
  instance: PropTypes.object.isRequired,
  onDeleteInstance: PropTypes.func.isRequired,
};

export default DeletionTab;
